import { TrackingEvent } from '@marketplace-web/observability/event-tracker-data'
import { ContentSource } from 'constants/tracking/content-sources'

type followUserEventArgs = {
  userId: number
  isFollowEvent: boolean
  contentSource?: ContentSource
}

type FollowUserEventExtra = {
  user_id: number
  content_source?: ContentSource
}

export const followUserEvent = ({
  userId,
  isFollowEvent,
  contentSource,
}: followUserEventArgs): TrackingEvent => {
  const eventName = isFollowEvent ? 'user.follow_user' : 'user.unfollow_user'

  const extra: FollowUserEventExtra = {
    user_id: userId,
  }

  if (isFollowEvent) extra.content_source = contentSource

  return {
    event: eventName,
    extra,
  }
}
